module.exports = __webpack_public_path__ + "static/media/logo.560289c7.png";